import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Typography, Space, message } from "antd";
import { FilePdfOutlined, RightOutlined } from "@ant-design/icons";
import axios from "axios";

const { Text } = Typography;

const PdfList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleView = (record) => {
    window.open(record.s3Url, "_blank");
  };

  const fetchPDFList = async () => {
    setLoading(true);
    try {
      const authToken = localStorage.getItem("token") || "";
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Pdf/office-to-pdf`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setData(response.data.data || []);
    } catch (error) {
      message.error("Failed to fetch PDF list");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPDFList();
  }, []);

  const columns = [
    {
      title: "File",
      key: "file",
      responsive: ["xs", "sm", "md", "lg"],
      render: (_, record) => (
        <Space onClick={() => handleView(record)} style={{ cursor: "pointer" }}>
          <FilePdfOutlined style={{ fontSize: 24, color: "red" }} />
          <Text strong style={{ wordBreak: "break-word" }}>
            {record.originalFileName || "Converted PDF"}
          </Text>
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      responsive: ["sm"],
      render: (status) => (
        <Tag color={status === "Converted" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Converted On",
      dataIndex: "uploadDate",
      key: "uploadDate",
      responsive: ["md"],
      render: (input) => {
        const date = new Date(input.split(".")[0]);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    {
      title: "",
      key: "view",
      align: "right",
      render: (record) => (
        <Button
          type="text"
          icon={<RightOutlined />}
          onClick={() => handleView(record)}
        />
      ),
    },
  ];

  return (
    <div style={{ padding: 12 }}>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowKey={(record) => record.key || record.id}
        scroll={{ x: "max-content" }} // Enables horizontal scroll on mobile
      />
    </div>
  );
};

export default PdfList;
